import React, { useState, useEffect, useCallback } from 'react';
import Button from 'carbon-components-react/lib/components/Button';
import RunAutomata from 'assets/image/Group_2.svg';
import i18n from "../../i18n";
import { useHistory } from 'react-router-dom';

require("./_run-automata.scss");


function redirect(){
    window.location.href = "/manage_operations";
}
const ExceptionRunAutomata = props => {
    const ManageOperations = i18n.t('runAutomata.manageOperations');
    const Error1 = i18n.t('runAutomata.Error');
    // const Error2 = i18n.t('scheduleRecommendation.Error2');
    // const Error3 = i18n.t('scheduleRecommendation.Error3');
    const history = useHistory();
    return (
        <div className="page-margin padding-top-30px">

            <div className="add-new-code-page-margin">
                <div className="add-new-main-run-automata">
                    <div className="add-new-main-segment-image-run-automata"><img src={RunAutomata} alt="" /></div>
                    <div className="add-new-main-segment">
                        <ul className="font-success carbon-display-Regular-20">{Error1}</ul>
                        {/* <ul className="font-success carbon-display-Regular-20">{Error2}</ul>
                        <ul className="font-success carbon-display-Regular-20">{Error3}</ul> */}
                        <ul><Button className="add-new-main-segment-button" kind="tertiary" onClick={redirect} >{ManageOperations}</Button></ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ExceptionRunAutomata;